import React, { useState, useEffect, useContext } from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  MenuItem,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";
import { Form, Formik } from "formik";
import DatePicker from "react-datepicker";

// User Import

import {
  BATCH_MAIN_TYPES_ENUM_ARRAY,
  USER_ROLES_ENUM,
  BATCH_CREATE_ENUMS,
  RequestEnumArr,
} from "../../../../common/Enums";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { headersPost } from "../../../../Services/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import { CustomDateInput } from "../../../../common/Components";
import { ministry_Context } from "../../../../context";
import { transferBatchSchema } from "../../../../Services/validations/MinistryPortal/Batch";

// Constant

const initialValues = {
  type: "transfer",
  main_type: "",
  sub_type: "",
  parent_batch_id: "",
  reference_number: "",
  new_reference_number: "",
  batch_type: "",
  // previous_temperature: "",
  // expiry_date: "",
  size: "",
  quantity: "",
  dispatch_date: "",
  receiver_id: "",
  note: "",
};

// Component

const IssuedBatch = () => {
  // Hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { provinces } = useContext(ministry_Context);

  //states

  const [formValue, setFormValue] = useState(initialValues);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [recieverArr, setRecieverArr] = useState([]);

  //form submit handler

  const formSubmitHanlder = (values) => {
    const data = {
      batch: {
        type: values.type,
        reference_number: values.reference_number,
        new_reference_number: values.new_reference_number,
        size: values.quantity,
        // previous_temperature: values.previous_temperature,
        // expiry_date: values.expiry_date,
        modifier_date: values.modifier_date,
        main_type: values?.main_type,
        sub_type: values?.sub_type,
        batch_type: values.batch_type,
        parent_batch_id: values?.parent_batch_id,
        receiver_id: values?.receiver_id,
        action: BATCH_CREATE_ENUMS.TRANSFER,
        dispatch_date: values?.dispatch_date,
        note: values?.note,
      },
    };

    setOpen(true);

    headersPost(MINISTRY_API_ULRS.APPROVE_REQUEST, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-1);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const getTypeHandler = (type) => {
    const data = {
      requests: {
        request_type: type,
      },
    };
    setOpen(true);

    headersPost(MINISTRY_API_ULRS.REQUEST_INVENTORY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setRecieverArr(res?.data?.receiver);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  
  // set form initial values

  useEffect(() => {
    state?.node?.id &&
      setFormValue((prev) => ({
        ...prev,
        parent_batch_id: state?.node?.id,
        main_type: state?.node.main_type,
        sub_type: state?.node.sub_type,
        size: state?.node?.available_quantity,
        reference_number: state?.node?.reference_number,
        previous_temperature: state?.node?.previous_temperature,
        expiry_date: state?.node?.expiry_date,
        modifier_date: state?.node?.modifier_date,
      }));
    return () => {
      setFormValue(initialValues);
    };
  }, [state?.node]);

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  // Render

  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",

        borderRadius: 1,
      }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"left"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Transfer Inventory
        </Typography>
        <Formik
          initialValues={formValue}
          onSubmit={formSubmitHanlder}
          validationSchema={transferBatchSchema}
          enableReinitialize
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 0, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                >
                  <Grid container marginBottom={5} spacing={{ xs: 3, sm: 4 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        disabled
                        name="main_type"
                        value={values?.main_type}
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        error={touched?.main_type && Boolean(errors?.main_type)}
                        helperText={touched?.main_type && errors?.main_type}
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      >
                        {/* <MenuItem disabled value={""}>
                          Select an Inventory
                        </MenuItem>
                        {BATCH_MAIN_TYPES_ENUM_ARRAY.map((option, index) => (
                          <MenuItem
                            value={option.value}
                            key={`${index}-batch-main-types-${option.value}`}
                          >
                            {option.name}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"text"}
                        name="sub_type"
                        value={values.sub_type}
                        error={touched?.sub_type && Boolean(errors?.sub_type)}
                        helperText={touched?.sub_type && errors?.sub_type}
                        fullWidth
                        disabled
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      >
                        {/* <MenuItem value={""} disabled>
                          Select an Category
                        </MenuItem>
                        {BATCH_SUB_TYPES_ENUM_ARRAY?.map((item, index) => (
                          <MenuItem
                            value={item.value}
                            key={`${index}-request-inventory-${item.value}`}
                          >
                            {item.name}
                          </MenuItem>
                        ))} */}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        name="reference_number"
                        onChange={handleChange}
                        disabled
                        error={
                          touched?.reference_number &&
                          Boolean(errors?.reference_number)
                        }
                        helperText={
                          touched?.reference_number && errors?.reference_number
                        }
                        value={values.reference_number}
                        placeholder="Please Enter Reference No."
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        name="new_reference_number"
                        type={"text"}
                        onChange={handleChange}
                        value={values?.new_reference_number}
                        error={
                          touched?.new_reference_number &&
                          Boolean(errors?.new_reference_number)
                        }
                        helperText={
                          touched?.new_reference_number &&
                          errors?.new_reference_number
                        }
                        placeholder={"Please enter new batch no"}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      ></TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        select
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        name="batch_type"
                        onChange={(e) => {
                          getTypeHandler(e.target.value);
                          setFieldValue("batch_type", e.target.value);
                        }}
                        type={"text"}
                        value={values?.batch_type}
                        error={
                          touched?.batch_type && Boolean(errors?.batch_type)
                        }
                        helperText={touched?.batch_type && errors?.batch_type}
                        // placeholder="Select Type"
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Select Type{" "}
                        </MenuItem>
                        {RequestEnumArr?.map((item, index) => (
                          <MenuItem
                            key={`${index}-request-${item.value}`}
                            value={item.value}
                          >
                            {item.name}{" "}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        select
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        name="receiver_id"
                        onChange={handleChange}
                        type={"text"}
                        value={values?.receiver_id}
                        error={
                          touched?.receiver_id && Boolean(errors?.receiver_id)
                        }
                        helperText={touched?.receiver_id && errors?.receiver_id}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      >
                        <MenuItem value={""} disabled>
                          Send to
                        </MenuItem>
                        {recieverArr?.map((item, index) => (
                          <MenuItem
                            key={`${index}-request-${item.id}`}
                            value={item.id}
                          >
                            {item.name}{" "}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        select
                        name="receiver_id"
                        value={values?.receiver_id}
                        SelectProps={{
                          displayEmpty: true,
                        }}
                        onChange={handleChange}
                        error={
                          touched?.receiver_id && Boolean(errors?.receiver_id)
                        }
                        helperText={touched?.receiver_id && errors?.receiver_id}
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      >
                        <MenuItem disabled value={""}>
                          Issued to
                        </MenuItem>
                        {provinces?.map((option, index) => (
                          <MenuItem
                            value={option?.id}
                            key={`${index}-batch-main-types-${option?.id}`}
                          >
                            {option?.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        fullWidth
                        name="previous_temperature"
                        onChange={handleChange}
                        disabled
                        error={
                          touched?.previous_temperature &&
                          Boolean(errors?.previous_temperature)
                        }
                        helperText={
                          touched?.previous_temperature &&
                          errors?.previous_temperature
                        }
                        value={values.previous_temperature}
                        placeholder="Please Enter Previous Temperate"
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            backgroundColor: `${theme.palette.secondary.dark}`,
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <DatePicker
                        selected={values.dispatch_date}
                        onChange={(date) =>
                          setFieldValue("dispatch_date", date)
                        }
                        minDate={new Date()}
                        selectsStart
                        placeholderText="Dispatch date"
                        name="dispatch_date"
                        customInput={
                          <CustomDateInput
                            size={"small"}
                            name={"dispatch_date"}
                            InputProps={{
                              readOnly: true,
                            }}
                            helperText={
                              touched?.dispatch_date && errors?.dispatch_date
                            }
                            error={
                              touched?.dispatch_date &&
                              Boolean(errors?.dispatch_date)
                            }
                          />
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        type={"number"}
                        name="quantity"
                        onChange={handleChange}
                        error={touched?.quantity && Boolean(errors?.quantity)}
                        helperText={touched?.quantity && errors?.quantity}
                        value={values.quantity}
                        placeholder="Please enter batch quantity"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <TextField
                        variant="outlined"
                        size={"small"}
                        rows={3}
                        type={"text"}
                        name="note"
                        onChange={handleChange}
                        error={touched?.note && Boolean(errors?.note)}
                        helperText={touched?.note && errors?.note}
                        value={values.note}
                        multiline
                        placeholder="Batch Description"
                        fullWidth
                        sx={{
                          border: "1px solid grey",
                          borderRadius: theme.spacing(1),

                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  {/* Button */}
                  <Grid container>
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"right"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          borderRadius: theme.spacing(1),
                          minWidth: "20%",
                        }}
                      >
                        {" "}
                        Done{" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        color={alertIcon}
        autoHideDuration={100000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon} color={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default IssuedBatch;
